import { ACHIEVEMENTS_VIEW_NAME, CHAT_VIEW_NAME, CONTENT_VIEW_NAME, DATA_VIEW_NAME, DOCUMENTATION_VIEW_NAME, EDITOR_VIEW_NAME, EMBED_VIEW_NAME, ERROR_VIEW_NAME, LAUNCH_VIEW_NAME, LECTURE_VIEW_NAME, LIST_VIEW_NAME, LOADING_VIEW_NAME, PORTAL_VIEW_NAME, QUEST_VIEW_NAME, VIEW_DATA } from "../core/constants";
import { store } from "../core/state";
import { isViewLoading } from "../core/views";
import { AchievementView } from "../views/AchievementView";
import { ChatView } from "../views/ChatView";
import { ContentView } from "../views/ContentView";
import { DataView } from "../views/DataView";
import { DocumentationView } from "../views/DocumentationView";
import { EditorView } from "../views/EditorView";

import { ErrorView } from "../views/ErrorView";
import { EmbedView } from "../views/EmbedView";
import { LaunchView } from "../views/LaunchView";
import { LectureView } from "../views/LectureView";
import { LoadingView } from "../views/LoadingView";
import { PortalView } from "../views/PortalView";
import { ProjectListView } from "../views/ProjectListView";
import QuestView from "../views/QuestView";

export function MainView() {
  const [viewState] = store.useState(VIEW_DATA);
  
  if (viewState && viewState.currentView) {
    if (isViewLoading()) {
      return <LoadingView />;
    }
    switch (viewState.currentView) {
      case ERROR_VIEW_NAME:
        return <ErrorView />;
      case LOADING_VIEW_NAME:
        return <LoadingView />;
      case CONTENT_VIEW_NAME:
        return <ContentView />;
      case EDITOR_VIEW_NAME:
        return <EditorView />;
      case LAUNCH_VIEW_NAME:
        return <LaunchView />;
      case EMBED_VIEW_NAME:
        return <EmbedView />;
      case LIST_VIEW_NAME:
        return <ProjectListView />;
      case PORTAL_VIEW_NAME:
        return <PortalView />;
      case ACHIEVEMENTS_VIEW_NAME:
        return <AchievementView />;
      case QUEST_VIEW_NAME:
        return <QuestView />;
      case CHAT_VIEW_NAME:
        return <ChatView />;
      case DATA_VIEW_NAME:
        return <DataView />;
      case LECTURE_VIEW_NAME:
          return <LectureView />;
      case DOCUMENTATION_VIEW_NAME:
          return <DocumentationView />;
      default:
        break;
    }
  }
  return <LoadingView />;
}
